import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import * as actions from './giftCardActions';
import styled from 'styled-components';
import Title1 from '../../components/Typography/Title1';
import AddNewGiftCard from './components/AddNewGiftCard';
import ConnectExistingGiftCard from './components/ConnectExistingGiftCard';
import ReloadGiftCard from './components/ReloadGiftCard';
import { setDefaultPaymentMethod } from '../PaymentMethods/paymentMethodsActions';
import { PrimaryButton } from '../../components/Buttons';
import appConfig from '../../../app-config';
import StickyErrorMessageBox from '../../components/ErrorMessage/StickyErrorMessageBox';
import { showPaymentMethodSelectionForm } from '../PaymentMethods/paymentMethodsActions';

const Transition = (props) => <Slide direction='up' {...props} />;
const ErrorMesageWrapper = styled.div`
  padding: 0;
  width: 450px;
  margin: 0;
`;
const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;
const Button = styled(PrimaryButton)`
  height: 56px;
  padding: 19px 16px 19px 24px;
  background-color: ${(props) =>
    props.isForAddGiftCard
      ? props.theme.primaryButtonBackgroundColor
      : props.theme.connectExistingGiftCardButtonBackgroundColor};
  color: ${(props) =>
    props.isForAddGiftCard
      ? props.theme.primaryButtonFontColor
      : props.theme.connectExistingGiftCardButtonTextColor};
  border: 2px solid
    ${(props) =>
      props.isForAddGiftCard
        ? props.theme.primaryButtonBackgroundColor
        : props.theme.connectExistingGiftCardButtonBorderColor};
  border-radius: ${(props) => props.theme.giftCardButtonRadius};
  font-size: 19px;
  margin-top: ${(props) => props.marginTop};
  &:hover {
    background-color: ${(props) =>
      props.isForAddGiftCard
        ? props.theme.primaryFillHoverStateBackgroundColor
        : props.theme.connectExistingGiftCardButtonHoverColor};
    color: ${(props) =>
      props.isForAddGiftCard
        ? props.theme.primaryFillHoverStateTextColor
        : props.theme.connectExistingGiftCardButtonTextHoverColor};
    border: 2px solid
      ${(props) =>
        props.isForAddGiftCard
          ? props.theme.primaryButtonBackgroundColor
          : props.theme.connectExistingGiftCardButtonBorderHoverColor};
    transition: all 0.25s ease;
  }
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const styles = () => ({
  root: {
    width: '100%',
    margin: 'auto',
    margin: 0,
  },
  paper: {
    margin: 0,
    width: '100%',
    boxShadow: 'none',
  },
  paper1: {
    margin: 0,
    width: '100%',
  },
  // backdrop: {
  //   backgroundColor: 'transparent',
  // },
});

const Wrapper = styled.div`
  display: grid;
  grid-gap: 24px;
  align-items: center;
  justify-self: center;
  margin: 24px;
`;

let GiftCardContainer = ({
  classes,
  giftCardReducer,
  initiateAddNewGiftCard,
  resetGiftCardReducer,
  initiateConnectExistingGiftCard,
  connectExistingGiftCard,
  paymentMethodsReducer,
  addFunds,
  reloadFunds,
  setDefaultPaymentMethod,
  removeGiftCard,
  showConfirmDeleteModal,
  hideConfirmDeleteModal,
  sourceConfig,
  giftCardErrors,
  clearGiftCardErrorMessage,
  showPaymentMethodSelectionForm,
}) => {
  const {
    isGiftCardModalVisible,
    isAddingGiftCard,
    isConnectingExistingGiftCard,
    isReloadingGiftCard,
    giftCardDetails,
    confirmDeleteGiftCardIsVisible,
  } = giftCardReducer;

  useEffect(() => {
    clearGiftCardErrorMessage();
  }, [
    isGiftCardModalVisible,
    isGiftCardModalVisible,
    isConnectingExistingGiftCard,
    isReloadingGiftCard,
  ]);
  const isAddGiftCardEnabled =
    sourceConfig && sourceConfig.gift_card_buy_enabled;

  const {
    paymentMethods,
    requestingDeletePaymentMethod,
    paymentMethodSelectionFormIsVisible,
  } = paymentMethodsReducer;
  const [paymentMethod, setPaymentMethod] = useState('');

  const handleConnectExistingGiftCard = (values) => {
    connectExistingGiftCard(values);
  };

  const handleAddFunds = (values) => {
    addFunds(values);
  };

  const handleReloadFunds = (values) => {
    reloadFunds(values);
  };

  const handleDefaultPaymentMethod = (defaultPaymentId) => {
    setDefaultPaymentMethod(defaultPaymentId);
    resetGiftCardReducer();
  };

  const handleRemoveGiftCard = (giftCardId) => {
    removeGiftCard(giftCardId);
  };

  useEffect(() => {
    if (paymentMethods) {
      setPaymentMethod(
        paymentMethods.filter(
          (paymentMethod) => paymentMethod.is_preferred == true
        )[0]
      );
    }
  }, [paymentMethods]);
  return (
    <Dialog
      id='GiftCard-Dialog'
      open={isGiftCardModalVisible}
      // style={{ zIndex: isReloadingGiftCard ? '1299' : '1300' }}
      onClose={() => resetGiftCardReducer()}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      TransitionComponent={Transition}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      classes={classes.root}
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
      PaperProps={{
        classes: { root: classes.paper1 },
      }}
      aria-labelledby='create-gift-card'
      overlayStyle={{ backgroundColor: 'transparent' }}
      scroll='body'
    >
      {giftCardErrors && Object.keys(giftCardErrors).length > 0 && (
        <ErrorMesageWrapper>
          <StickyErrorMessageBox
            errors={giftCardErrors}
            marginTop='0'
            messageWidth='100%'
          />
        </ErrorMesageWrapper>
      )}
      <Wrapper>
        <TitleWrapper>
          <Title1>
            {isAddingGiftCard && `${appConfig.appTitle} Gift Card`}
            {isConnectingExistingGiftCard && 'Connect a Gift Card'}
            {isReloadingGiftCard && `${appConfig.appTitle} Gift Card`}
            {!isAddingGiftCard &&
              !isConnectingExistingGiftCard &&
              !isReloadingGiftCard &&
              'Add a Gift Card'}
          </Title1>
          <Cancel onClick={() => resetGiftCardReducer()}>
            <i className='fal fa-times' />
          </Cancel>
        </TitleWrapper>
        {isAddingGiftCard && (
          <AddNewGiftCard
            id='GiftCard-AddNewGiftCard'
            handleAddFunds={handleAddFunds}
            paymentMethod={paymentMethod}
            sourceConfig={sourceConfig}
          />
        )}
        {isConnectingExistingGiftCard && (
          <ConnectExistingGiftCard
            id='GiftCard-ConnectExistingGiftCard'
            handleConnectExistingGiftCard={handleConnectExistingGiftCard}
          />
        )}
        {isReloadingGiftCard && (
          <ReloadGiftCard
            id='GiftCard-ReloadGiftCard'
            giftCardDetails={giftCardDetails}
            handleReloadFunds={handleReloadFunds}
            handleDefaultPaymentMethod={handleDefaultPaymentMethod}
            handleRemoveGiftCard={handleRemoveGiftCard}
            requestingDeletePaymentMethod={requestingDeletePaymentMethod}
            showConfirmDeleteModal={showConfirmDeleteModal}
            hideConfirmDeleteModal={hideConfirmDeleteModal}
            confirmDeleteGiftCardIsVisible={confirmDeleteGiftCardIsVisible}
            sourceConfig={sourceConfig}
            defaultPaymentMethod={paymentMethod}
          />
        )}

        {!isAddingGiftCard &&
          !isConnectingExistingGiftCard &&
          !isReloadingGiftCard && (
            <Fragment>
              <Button
                id='GiftCard-ConnectButton'
                onClick={() => initiateConnectExistingGiftCard()}
                isForAddGiftCard={false}
                marginTop='8px'
              >
                Connect an existing Gift Card
              </Button>

              {isAddGiftCardEnabled ? (
                <Button
                  id='GiftCard-CreateNewButton'
                  onClick={() => {
                    showPaymentMethodSelectionForm(false);
                    initiateAddNewGiftCard();
                  }}
                  isForAddGiftCard={true}
                >
                  Create a Digital Gift Card
                </Button>
              ) : null}
            </Fragment>
          )}
      </Wrapper>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  giftCardReducer: state.giftCardReducer,
  paymentMethodsReducer: state.paymentMethodsReducer,
  sourceConfig: state.authReducer.appConfig,
  giftCardErrors: state.giftCardReducer.giftCardErrors,
});

export default withStyles(styles)(
  connect(mapStateToProps, {
    ...actions,
    setDefaultPaymentMethod,
    showPaymentMethodSelectionForm,
  })(GiftCardContainer)
);
